(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('NasracPackage', NasracPackage);

    NasracPackage.$inject = ['$resource'];

    function NasracPackage ($resource) {
        var resourceUrl =  'api/nasrac-packages/:id';
        var xlsxContentType = 'application/octet-stream';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'download' : {
				method : 'GET',
				url : 'api/nasrac-packages/download',
				headers: {
					accept: xlsxContentType
		        },
		        responseType: 'arraybuffer',
		        cache: false,
		        transformResponse: function (data) {
		          return {
			            response: new Blob([data], {type: xlsxContentType})
			          };
		        }
			},
            'downloadUserAccounts' : {
                method : 'GET',
                url : 'api/nasrac-packages/downloadUserAccounts',
                headers: {
                    accept: xlsxContentType
                },
                responseType: 'arraybuffer',
                cache: false,
                transformResponse: function (data) {
                    return {
                        response: new Blob([data], {type: xlsxContentType})
                    };
                }
            }

        });
    }
})();
